import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralComponent } from '../../General/g.component';
import { NgForm } from '@angular/forms';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';
import { HttpClient } from '@angular/common/http';
import * as shape from 'd3-shape';
import { SelfcorrectingService } from '../selfcorrecting.service';

@Component({
  selector: 'app-playground',
  templateUrl: './playground.component.html',
  styleUrls: ['../topic-style.css', './playground.component.css']
})
export class PlaygroundComponent extends GeneralComponent {

  exerciseType: string = "";

  solved = false;

  possibleTexts: string[] = [];

  //Intuitive
  cloe: string;
  variations: string[];

  errorCount: number;
  countPossibleAnswers: number;

  selected: boolean[] = [];

  //distances
  words: string[];
  wordsS: string;
  givenPairs: boolean;

  pairs: string[][];
  distances: number[] = [];
  errors: number[] = [];

  possibleWords: string[][] = [];

  //createCodes
  lengthOfCodes: number;
  numberOfCodes: number;
  minimalDistance: number;
  values: string[] = [];
  codes: string[] = [];
  showCube: boolean;

  countErrors: number;
  useValues: boolean;
  existingCodes: boolean;
  noLength: boolean;
  noCount: boolean;
  modus: string = "";

  view: any[] = [600, 300];
  fitContainer: boolean = true;
  curve = shape.curveBundle;
  nodes: any[] = [];
  edges: any[] = [];
  noCodes: string[] = [];

  //controlBits
  message: string = "";
  dimension: number[] = [0, 0];
  encoding: string = "cardTrick";
  useSymbols: boolean = false;

  length: number;
  hamming: string;

  showMessage: string = "";
  messageWithC: string = "";

  messageArray: number[][] = [];

  c: number[] = [];
  p: string[] = [];

  highlight: boolean = false;

  currentRow: number;
  currentColumn: number;

  selectedRow: number;
  selectedColumn: number;

  correctedMessage: string;

  currentParity: number[] = [];

  //reversed Card

  wrongBit: number = undefined;

  //modulo
  withMessage: boolean = false;

  formula: string[] = [];
  formulaFilled: string[] = [];

  @ViewChild('definitionForm', {static:true}) public definitionForm: NgForm;
  constructor(topicService: TopicService, protected messageService: MessageService, protected selfcorrectingService: SelfcorrectingService, protected http: HttpClient) {
    super(topicService);
    this.loadText();
  }

  /** loads the text to generate words from */
  loadText(): Promise<any> {
    let textFile = "./assets/text_" + this.topicService.getLanguage() + ".txt";
    let self = this;
    return new Promise((resolve, reject) => {
      this.http
        .get<any>(textFile)
        .subscribe(response => {
          self.possibleWords = response.wordDistance;
          console.log(self.possibleWords)
          resolve(true);
        })
    })
  }

  reset() {
    this.solved = false;
    this.cloe = "";
    for (let i = 0; i < 5; i++) {
      this.cloe = this.cloe.concat((Math.random() > 0.5 ? "0" : "1"));
    }
    if (this.cloe == "00000" || this.cloe == "11111") {
      this.cloe = "10111";
    }

    //Intuitive
    this.variations = [];

    this.errorCount = undefined;
    this.countPossibleAnswers = undefined;

    this.selected = [];

    //distances
    this.words = [];
    this.wordsS = undefined;
    this.givenPairs = false;

    this.pairs = undefined;
    this.distances = [];
    this.errors = [];

    this.possibleWords = [];

    //createCodes
    this.lengthOfCodes = undefined;
    this.numberOfCodes = undefined;
    this.minimalDistance = undefined
    this.values = [];
    this.codes = [];
    this.showCube = false;

    this.countErrors = undefined;
    this.useValues = false;
    this.existingCodes = false;
    this.noLength = false;
    this.noCount = false;
    this.modus = "";

    this.nodes = [];
    this.edges = [];
    this.noCodes = [];

    //controlBits
    this.message = "";
    this.dimension = [0, 0];
    this.encoding = "cardTrick";
    this.useSymbols = false;

    this.length = undefined;
    this.hamming = undefined

    this.showMessage = "";
    this.messageWithC = "";

    this.messageArray = [];

    this.c = [];
    this.p = [];

    this.highlight = false;

    this.currentRow = -1;
    this.currentColumn = -1;

    this.selectedRow = -1;
    this.selectedColumn = -1;

    this.correctedMessage = undefined;

    this.currentParity = [];

    //reversed Card

    this.wrongBit = undefined;

    //modulo
    this.withMessage = false;

    this.formula = [];
    this.formulaFilled = [];

  }

  // Intuitive ----------------------------------------------------------------------------------------------------------------------------------------
  generateIntuitive() {
    this.errorCount = Math.random() > 0.5 ? 1 : 2;
    this.countPossibleAnswers = Math.floor(Math.random() * 4);
    this.onChange();
  }

  onChange() {
    if (this.errorCount != undefined && this.countPossibleAnswers != undefined) {
      let correctAnswers = this.selfcorrectingService.distanceSmallerEqual(5, this.errorCount, this.cloe);
      let wrongAnswers = this.selfcorrectingService.distanceLarger(5, this.errorCount, this.cloe);

      this.variations = [];
      for (let i = 0; i < this.countPossibleAnswers; i++) {
        this.variations.push(correctAnswers.splice(Math.floor(Math.random() * correctAnswers.length), 1)[0]);
      }
      for (let i = 0; i < 4 - this.countPossibleAnswers; i++) {
        this.variations.push(wrongAnswers.splice(Math.floor(Math.random() * wrongAnswers.length), 1)[0]);
      }
      this.shuffleArray(this.variations);
      this.selected = new Array(this.variations.length).fill(false);
    }
  }

  shuffleArray(array) {
    for (var i = array.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
  }

  checkSolutionIntuitive() {
    let solution = this.variations.map((v) => this.selfcorrectingService.distance(v, this.cloe) <= this.errorCount);
    console.log(this.selected);
    if (solution.filter((v, i) => v != this.selected[i]).length == 0) {
      this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
      this.solved = true;
    } else {
      this.messageService.addAlertWithTimeout(this.get("notYetCorrect"), "danger", 10000);
    }
  }


  // distances ********************************************************************************
  onChangeWords() {
    this.words = this.wordsS.split(/[, \n]+/).map(v => v.toUpperCase());
    this.wordsS = this.words.join(", ");
    console.log(this.givenPairs);
    if (this.givenPairs) {
      this.pairs = [];
      for (let i = 0; i < this.words.length; i++) {
        for (let j = 0; j < i; j++) {
          this.pairs.push([this.words[i], this.words[j]]);
        }
      }
    } else {
      this.pairs = [];
    }
    console.log(this.pairs);
  }

  generateDistances() {
    this.givenPairs = Math.random() > 0.5;
    this.generateText();
    this.onChangeWords();

  }

  generateText() {
    let index = Math.floor(Math.random() * this.possibleWords.length);
    this.words = this.possibleWords[index];
    this.wordsS = this.words.join(", ");
    this.onChangeWords();
  }

  checkSolutionDistances() {
    let pairs = [];
    for (let i = 0; i < this.words.length; i++) {
      for (let j = 0; j < i; j++) {
        pairs.push([this.words[i], this.words[j]]);
      }
    }
    let missingPairs = [];
    let doublePairs = [];
    let map = [];
    let i = 0;
    for (let ps of pairs) {
      let found = false;
      let j = 0;
      for (let p of this.pairs) {
        if ((ps[0] == p[0] && ps[1] == p[1]) || (ps[0] == p[1] && ps[1] == p[0])) {
          if (found) {
            doublePairs.push(p);
          } else {
            found = true;
            map[i] = j;
          }
        }
        j++;
      }
      if (!found) {
        missingPairs.push(ps);
      }
      i++;
    }
    if (missingPairs.length > 0) {
      this.messageService.addAlertWithTimeout(this.get("missingPairs").concat(": ", missingPairs.map((v => "[".concat(v[0], ", ", v[1], "]"))).join(", ").toString()), "danger", 10000);
      //return;
    }
    if (doublePairs.length > 0) {
      this.messageService.addAlertWithTimeout(this.get("doublePairs").concat(": ", doublePairs.map((v => "[".concat(v[0], ", ", v[1], "]"))).join(", ").toString()), "danger", 10000);
      //return;
    }
    if (doublePairs.length > 0 || missingPairs.length > 0) {
      return;
    }
    let solution = pairs.map(v => this.selfcorrectingService.distance(v[0], v[1]));
    i = 0;
    this.errors = [];
    for (let i of this.createArray(pairs.length)) {
      if (this.distances[map[i]] != solution[i]) {
        this.errors.push(map[i]);
      }
      i++;
    }

    if (this.errors.length > 0) {
      this.messageService.addAlertWithTimeout(this.get("wrongDistances"), "danger", 10000);
    } else {
      this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
      this.solved = true;
    }
  }

  addPair(position: number, event: any) {
    let elem = [];
    elem[position] = event.dragData;
    this.pairs.push(elem);
  }

  addToPair(pair: number, position: number, event: any) {
    this.pairs[pair][position] = event.dragData;
  }


  // create codes --------------------------------------------------------------------------------------------------------------------------------------------------------
  normalizeCode(code: string) {
    return code.replace(/[^01]/, "");
  }

  computeGraph() {
    if (this.lengthOfCodes < 6 && this.lengthOfCodes > 1) {
      this.nodes = [];
      this.edges = [];
      let nodeList = this.selfcorrectingService.allCodes(this.lengthOfCodes);
      for (let n of nodeList) {
        this.nodes.push({
          id: n,
          label: n
        });
      }

      for (let i = 0; i < nodeList.length; i++) {
        for (let j = 0; j < i; j++) {
          if (this.selfcorrectingService.distance(nodeList[i], nodeList[j]) == 1) {
            this.edges.push({
              source: nodeList[i],
              target: nodeList[j],
              label: ''
            })
          }
        }
      }
    } else /*if (this.codes.length > 0)*/ {
      this.nodes = [];
      this.edges = [];
      for (let n of this.codes) {
        this.nodes.push({
          id: n,
          label: n
        });
      }

      for (let i = 0; i < this.codes.length; i++) {
        for (let j = 0; j < i; j++) {
          this.edges.push({
            source: this.codes[i],
            target: this.codes[j],
            label: this.selfcorrectingService.distance(this.codes[i], this.codes[j])
          })
        }
      }
    }
  }

  maxCodes(length: number, distance: number) {
    if (this.noLength) {
      length = 7;
    }
    if (distance == 2) {
      return Math.min(Math.pow(2, length - distance + 1), 8);
    } else {
      if (length == 2) {
        return 1
      }
      if (length == 3) {
        return 2
      }
      return Math.min(Math.pow(2, length - distance), 8);
    }
  }

  generateCreateCodes() {
    this.modus = Math.random() > 0.5 ? "countError" : "lengthDistance";
    this.lengthOfCodes = Math.ceil(Math.random() * 5 + 1);
    this.minimalDistance = Math.ceil(Math.random() * 2 + 1);
    while (this.maxCodes(this.lengthOfCodes, this.minimalDistance) < 2) {
      this.lengthOfCodes++;
    }
    this.numberOfCodes = Math.floor(Math.random() * (this.maxCodes(this.lengthOfCodes, this.minimalDistance) - 2) + 2);
    this.countErrors = this.minimalDistance - 1;
    this.modus = Math.random() > 0.5 ? 'error' : 'distance';
    this.computeGraph();
  }

  checkSolutionCreateCodes() {

    if (this.codes.length != this.numberOfCodes) {
      this.messageService.addAlertWithTimeout(this.get("wrongNumberofCodes"), "danger", 10000);
      return;
    }
    this.errors = this.codes.map((v, i) => [v, i]).filter(v => v[0].toString().length != this.lengthOfCodes && this.lengthOfCodes != undefined).map(v => +v[1]);
    if (this.errors.length > 0) {
      this.messageService.addAlertWithTimeout(this.get("wrongLengthOfCodes"), "danger", 10000);
      return;
    }
    if (this.selfcorrectingService.minDistance(this.codes) < this.minimalDistance) {
      let pairs = [];
      for (let i = 0; i < this.codes.length; i++) {
        for (let j = 0; j < i; j++) {
          pairs.push([this.codes[i], this.codes[j]]);
        }
      }
      let wrongPairs = pairs.map(v => [v[0], v[1], this.selfcorrectingService.distance(v[0], v[1])]).filter(v => v[2] < this.minimalDistance).map(v => [v[0], v[1]]);
      this.messageService.addAlertWithTimeout(this.get("tooLargeMinimalDistance").concat(": ", wrongPairs.map(v => "[".concat(v[0].toString(), ",", v[1].toString(), "]")).join("")), "danger", 10000);
      return;
    }
    this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
    this.solved = true;
  }

  selectNode(label: string) {
    if (this.noCodes.includes(label) || this.codes.includes(label)) {
      return;
    }
    let i = 0;
    while (i < this.numberOfCodes) {
      if (this.codes[i] == "" || this.codes[i] == undefined) {
        this.codes[i] = label;
        break;
      }
      i++;
    }
    this.noCodes.push(...this.selfcorrectingService.distanceSmallerEqual(label.length, this.minimalDistance - 1, label));

  }

  deleteCode(i: number) {
    this.codes[i] = "";
    let temp = this.codes.filter(v => v != null && v != undefined && v != "").map(v => this.selfcorrectingService.distanceSmallerEqual(v.length, this.minimalDistance - 1, v));
    this.noCodes = [].concat(...temp);
  }

  changeCode(i: number) {
    if (this.codes[i].length == this.lengthOfCodes) {
      let temp = this.codes.filter(v => v != null && v != undefined && v != "").map(v => this.selfcorrectingService.distanceSmallerEqual(v.length, this.minimalDistance - 1, v));
      this.noCodes = [].concat(...temp);
    } else if (this.codes[i] == null || this.codes[i] == undefined || this.codes[i].length == 0) {
      this.deleteCode(i);
    }
    this.computeGraph();

  }

  // ControlBits ---------------------------------------------------------------------------------------------------------------------------------------------------------------------
  generateControlBits() {
    this.dimension[0] = Math.ceil(Math.random() * 5);
    this.dimension[1] = Math.ceil(Math.random() * 5);
    this.message = this.generate01(this.dimension[0] * this.dimension[1])
    this.modus = Math.random() > 0.5 ? 'controlBits' : 'encode';
    this.encoding = "cardTrick";
    this.highlight = true;
    this.computeShowMessage();


    this.messageArray = [];
    if (this.encoding == "cardTrick") {
      this.fillArray();
    }
    this.changeMessage();

    this.computeLength();
  }

  generate01(length: number) {
    let result = "";
    for (let i = 0; i < length; i++) {
      result = result.concat((Math.random() > 0.5 ? "0" : "1"));
    }
    return result;
  }

  changeDimension() {
    console.log(this.messageArray);
    if (this.modus != "reversedCard") {
      this.message = this.messageArray.map(v => v.join("")).join("");
    }

    this.messageArray = [];
    let index = 0;
    for (let i = 0; i < this.dimension[0]; i++) {
      let elem = [];
      for (let j = 0; j < this.dimension[1]; j++) {
        if (this.modus == "controlBits") {
          elem[j] = this.message.charAt(index);
        } else if (this.modus == "reversedCard") {
          elem[j] = this.showMessage.charAt(index);
        } else {
          elem[j] = "";
        }
        index++;
      }
      this.messageArray.push(elem);
    }
    console.log(this.messageArray);
    this.length = this.dimension[0] * this.dimension[1];
  }

  fillArray() {
    console.log("fill Array " + this.showMessage);
    if (this.encoding == "cardTrick") {
      this.messageArray = [];
      let index = 0;
      for (let i = 0; i < this.dimension[0]; i++) {
        let elem = [];
        for (let j = 0; j < this.dimension[1]; j++) {
          if (this.modus == "controlBits") {
            elem[j] = this.message.charAt(index);
          } else if (this.modus == "reversedCard") {
            elem[j] = this.showMessage.charAt(index);
          } else {
            elem[j] = "";
          }
          index++;
        }
        this.messageArray.push(elem);
      }
      console.log(this.messageArray);
    }
  }

  changeMessage() {
    this.c = [];
    if (this.encoding == "cardTrick") {
      if (this.modus == "reversedCard") {
        this.controlBits();
      }
      this.computeShowMessage();
      this.fillArray();
      this.onChangeC();
    } else {
      // compute the corrupted message and reset the c and p
      // optionaly compute the corrected Message
      this.c = [];
      this.p = [];
      this.correctedMessage = "";
      this.wrongBit = undefined;
      if (this.modus == "reversedCard" || this.modus == "correctMessage") {
        this.computeCorruptedMessage();
        this.hammingCode();
        if (this.modus == "reversedCard") {
          this.computeCorrectMessage();
        }
      } else {
        this.computeShowMessage();
        this.hammingCode();
        if (this.modus == "controlBits") {
          this.correctedMessage = this.showMessage;
        }
      }
    }
  }

  controlBits() {
    console.log("hello" + this.message);
    if (this.modus == "reversedCard") {
      let messageArrayRight = [];
      let index = 0;
      for (let i = 0; i < this.dimension[0]; i++) {
        let elem = [];
        for (let j = 0; j < this.dimension[1]; j++) {
          elem[j] = this.message.charAt(index);
          index++;
        }
        messageArrayRight.push(elem);
      }

      this.c = this.selfcorrectingService.controlBits(messageArrayRight, this.dimension);
      console.log("controlBits" + this.c.toString());
    }
    //this.message = this.messageArray.map(v => v.join("")).join("");
  }

  hammingCode() {
    if (this.encoding == "hammingCode") {
      this.length = 11;
      this.p[0] = "";
      this.p[1] = "";
      this.p[2] = "";
      this.p[3] = "";
      if (this.modus == "controlBits" || this.modus == "reversedCard") {
        for (let i of this.selfcorrectingService.allCodes(4)) {
          if (i != "0000" && (!this.powerOfTwo(parseInt(i, 2)) || this.modus == "reversedCard")) {
            for (let j = 0; j < 4; j++) {
              if (i.charAt(j) == "1") {
                this.p[3 - j] = this.p[3 - j].concat(this.showMessage.charAt(parseInt(i, 2) - 1), " ");
              }
            }
          }
        }
      }
    }
  }

  computeCorruptedMessage() {
    //compute message with placeholders
    let correctMessage = "";
    let dataI = 0;
    let parityI = 0;
    for (let i = 1; i < 16; i++) {
      if (this.powerOfTwo(i)) {
        correctMessage = correctMessage.concat("c");
        parityI++;
      } else {
        correctMessage = correctMessage.concat(this.message.charAt(dataI));
        dataI++;
      }
    }

    //compute p and c
    let c = [];
    let p = [];
    this.length = 11;
    p[0] = "";
    p[1] = "";
    p[2] = "";
    p[3] = "";
    for (let i of this.selfcorrectingService.allCodes(4)) {
      if (i != "0000" && !this.powerOfTwo(parseInt(i, 2))) {
        for (let j = 0; j < 4; j++) {
          if (i.charAt(j) == "1") {
            p[3 - j] = p[3 - j].concat(correctMessage.charAt(parseInt(i, 2) - 1), " ");
          }
        }
      }

    }
    c = p.map(v => v.split("").map(v => +v).reduce((a, b) => a + b, 0)).map(v => v % 2);

    //compute correct Message
    parityI = 0;
    dataI = 0;
    correctMessage = "";
    for (let i = 1; i < 16; i++) {
      if (this.powerOfTwo(i)) {
        correctMessage = correctMessage.concat(c[parityI].toString());
        parityI++;
      } else {
        correctMessage = correctMessage.concat(this.message.charAt(dataI));
        dataI++;
      }
    }

    //corrupt Message
    let index = Math.floor(Math.random() * correctMessage.length);
    this.showMessage = correctMessage.substr(0, index).concat((1 - +correctMessage.charAt(index)).toString(), correctMessage.substr(index + 1, correctMessage.length));
  }


  toString(i: number, length: number) {
    return "0".repeat(length).concat(i.toString(2)).slice(-length);
  }

  computeLength() {
    if (this.encoding == "cardTrick") {
      this.length = this.dimension[0] * this.dimension[1];
    } else {
      this.length = 11;
    }
    this.useSymbols = false;
  }

  powerOfTwo(x: number): boolean {
    return (Math.log(x) / Math.log(2)) % 1 === 0
  }

  pow2(i: number): number {
    return Math.pow(2, i);
  }

  onChangeC() {
    if (this.modus == "controlBits" || this.modus == "reversedCard") {
      if (this.encoding == "cardTrick") {
        let message = this.messageArray.map(v => v.join("")).join("");
        this.correctedMessage = message.concat(this.c.join(""));
      } else {
        this.computeCorrectMessage();
      }
    } else {
      this.correctedMessage = "";
    }
  }

  computeShowMessage() {
    let dataI = 0;
    let parityI = 0;
    this.showMessage = "";
    if (this.encoding == "hammingCode") {
      for (let i = 1; i < 16; i++) {
        if (this.powerOfTwo(i)) {
          if (this.c[parityI] != undefined) {
            this.showMessage = this.showMessage.concat(this.c[parityI].toString());
          } else {
            this.showMessage = this.showMessage.concat("c");
          }
          parityI++;
        } else {
          this.showMessage = this.showMessage.concat(this.message.charAt(dataI));
          dataI++;
        }
      }
    }
    if (this.modus == "reversedCard" || this.modus == "correctMessage") {
      if (this.encoding == 'cardTrick') {
        let index = Math.floor(Math.random() * this.dimension[0] * this.dimension[1]);
        console.log("showMessage c " + this.c.toString());
        this.showMessage = this.message.substr(0, index).concat((1 - +this.message.charAt(index)).toString(), this.message.substr(index + 1, this.message.length), this.c.join(""));
      }
    }
  }

  computeCorrectMessage() {
    let dataI = 0;
    let parityI = 0;
    this.correctedMessage = "";
    if (this.modus != "reversedCard") {
      for (let i = 1; i < 16; i++) {
        if (this.powerOfTwo(i)) {
          if (this.c[parityI] != undefined && this.c[parityI].toString() != "") {
            this.correctedMessage = this.correctedMessage.concat(this.c[parityI].toString());
          } else {
            this.correctedMessage = this.correctedMessage.concat("c");
          }
          parityI++;
        } else {
          this.correctedMessage = this.correctedMessage.concat(this.message.charAt(dataI));
          dataI++;
        }
      }
    } else {
      this.correctedMessage = this.showMessage;
    }
  }


  normalize(s: any): string {
    if (s == undefined) {
      return "";
    }
    return s.toString().replace(/[^01]/, "");
  }

  computeCurrentParitiy(i: number) {
    if (this.encoding == "hammingCode") {
      this.currentParity = [];
      for (let j of this.selfcorrectingService.allCodes(4)) {
        if (j != "0000") {
          if (j.charAt(3 - i) == "1") {
            this.currentParity.push(parseInt(j, 2));
          }
        }
      }
    } else {
      this.currentParity = [i];
    }
  }

  onKeyUp(oField) {
    if (oField.selectionStart || oField.selectionStart == '0') {
      this.currentParity = [oField.selectionStart + 1];
    }
  }

  changeC(i: number) {
    if (this.c[i] == 0) {
      this.c[i] = 1;
    } else {
      this.c[i] = 0;
    }
    this.onChangeC();
  }

  checkSolutionControlBits() {
    let solution = "";
    if (this.encoding == "cardTrick") {
      let messageArray = [];
      let index = 0;
      for (let i = 0; i < this.dimension[0]; i++) {
        let elem = [];
        for (let j = 0; j < this.dimension[1]; j++) {
          elem[j] = this.message.charAt(index);
          index++;
        }
        messageArray.push(elem);
      }
      let correctc = this.selfcorrectingService.controlBits(messageArray, this.dimension);
      solution = this.message.concat(correctc.join(""));
    } else {
      let p = [];
      p[0] = "";
      p[1] = "";
      p[2] = "";
      p[3] = "";
      for (let i of this.selfcorrectingService.allCodes(4)) {
        if (i != "0000" && !this.powerOfTwo(parseInt(i, 2))) {
          for (let j = 0; j < 4; j++) {
            if (i.charAt(j) == "1") {
              p[3 - j] = p[3 - j].concat(this.showMessage.charAt(parseInt(i, 2) - 1), " ");
            }
          }
        }
      }
      let c = p.map(v => v.split("").map(v => +v).reduce((a, b) => a + b, 0)).map(v => v % 2);
      let dataI = 0;
      let parityI = 0;
      for (let i = 1; i < 16; i++) {
        if (this.powerOfTwo(i)) {
          solution = solution.concat(c[parityI].toString());
          parityI++;
        } else {
          solution = solution.concat(this.message.charAt(dataI));
          dataI++;
        }
      }
    }
    if (this.correctedMessage == solution) {
      this.solved = true;
      this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
    } else {
      this.messageService.addAlertWithTimeout(this.get("wrongAnswer"), "danger", 10000);
    }
  }


  //reverseBit -----------------------------------------------------------------------------------------------------------------------------------------------------------
  generateReverseBit() {
    this.encoding = "cardTrick";
    this.dimension[0] = Math.ceil(Math.random() * 5);
    this.dimension[1] = Math.ceil(Math.random() * 5);
    this.message = this.generate01(this.dimension[0] * this.dimension[1])
    this.modus = Math.random() > 0.5 ? 'reversedCard' : 'correctMessage';
    this.highlight = true;
    this.computeShowMessage();

    if (this.encoding == "cardTrick") {
      this.fillArray();
    }
    this.changeMessage();
    this.computeLength();
  }

  onChangeWrongBit() {
    if (this.modus == "reversedCard") {
      this.correctedMessage = this.showMessage.substr(0, this.wrongBit - 1).concat((1 - +this.showMessage.charAt(this.wrongBit - 1)).toString(), this.showMessage.substr(this.wrongBit - 1 + 1, this.showMessage.length))
    }
  }

  onClickRow() {
    this.selectedRow = this.currentRow;
    if (this.modus == "reversedCard") {
      let index = this.selectedRow * this.dimension[1] + this.selectedColumn;
      this.correctedMessage = this.showMessage.substr(0, index).concat((1 - +this.showMessage.charAt(index)).toString(), this.showMessage.substr(index + 1, this.showMessage.length))
    }
  }

  onClickColumn() {
    this.selectedColumn = this.currentColumn;
    if (this.modus == "reversedCard") {
      let index = this.selectedRow * this.dimension[1] + this.selectedColumn;
      this.correctedMessage = this.showMessage.substr(0, index).concat((1 - +this.showMessage.charAt(index)).toString(), this.showMessage.substr(index + 1, this.showMessage.length))
    }

  }

  onEnterRow(i: number) {
    this.currentRow = i;
  }

  onEnterColumn(i: number) {
    this.currentColumn = i;
  }

  resetCurrent() {
    this.currentRow = undefined;
    this.currentColumn = undefined;
  }

  checkSolutionReversedBit() {
    let solution = this.selfcorrectingService.reconstruct(this.showMessage, this.encoding, this.dimension);
    console.log(solution);
    if (this.correctedMessage == solution) {
      this.solved = true;
      this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
    } else {
      this.messageService.addAlertWithTimeout(this.get("wrongAnswer"), "danger", 10000);
    }
  }

  // Modulo -----------------------------------------------------------------------------------------------------------------------------------------------------------
  generateModulo() {
    console.log(this.message);
    this.dimension[0] = Math.ceil(Math.random() * 5);
    this.dimension[1] = Math.ceil(Math.random() * 5);
    if (Math.random() > 0.5) {
      this.message = this.generate01(this.dimension[0] * this.dimension[1])
      this.withMessage = true;
      this.fillArray();
    } else {
      this.message = "";
      this.withMessage = false;
    }
  }

  checkSolutionModulo() {
    //check the formulas
    let solutionFormula = [];
    let error = []
    for (let i = 0; i < this.dimension[0] + this.dimension[1] + 1; i++) {
      solutionFormula.push([]);
      error.push(false);
    }

    for (let i = 0; i < this.dimension[1]; i++) {
      solutionFormula[i] = [];
      let index = i;
      while (index < this.dimension[0] * this.dimension[1]) {
        solutionFormula[i].push(index);
        index += this.dimension[1]
      }
    }


    for (let i = 0; i < this.dimension[0]; i++) {
      solutionFormula[i + this.dimension[1]] = [];
      for (let j = 0; j < this.dimension[1]; j++) {
        solutionFormula[i + this.dimension[1]].push(i * this.dimension[1] + j);
      }
    }

    for (let i = 0; i < this.dimension[1] + this.dimension[0]; i++) {
      if (!this.formula[i]) {
        error[i] = true;
        continue;
      }
      let allParts = this.formula[i].split(" ").filter(v => v != "⊕");
      for (let p of solutionFormula[i]) {
        if (!allParts.includes("a".concat((p + 1).toString()))) {
          error[i] = true;
        }
      }
    }

    if (!this.formula[this.dimension[1] + this.dimension[0]]) {
      error[this.dimension[1] + this.dimension[0]] = true;
    } else {

      let allParts = this.formula[this.dimension[1] + this.dimension[0]].split(" ").filter(v => v != "⊕");
      let error1 = false;
      let error2 = false;
      for (let i = 0; i < this.dimension[1]; i++) {
        if (!allParts.includes("c".concat((i + 1).toString()))) {
          error1 = true;
        }
      }

      for (let i = this.dimension[1]; i < this.dimension[1] + this.dimension[0]; i++) {
        if (!allParts.includes("c".concat((i + 1).toString()))) {
          error2 = true;
        }
      }

      error[this.dimension[1] + this.dimension[0]] = error1 && error2;
    }

    if (error.filter(v => v).length > 0) {
      this.messageService.addAlertWithTimeout(this.get("errorInFormula").concat(": ", error.map((v, i) => [v, i + 1]).filter(v => v[0]).map(v => "c".concat(v[1])).join(", ")), "danger", 10000);
      return;
    }

    if (this.message == "" || this.message == undefined) {
      this.solved = true;
      this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
      return;
    }

    //check the applied formulas
    let messageArray = [];
    let index = 0;
    for (let i = 0; i < this.dimension[0]; i++) {
      let elem = [];
      for (let j = 0; j < this.dimension[1]; j++) {
        elem[j] = this.message.charAt(index);
        index++;
      }
      messageArray.push(elem);
    }
    let correctc = this.selfcorrectingService.controlBits(messageArray, this.dimension);

    error.fill(false);
    for (let i = 0; i < this.dimension[1] + this.dimension[0] + 1; i++) {
      if (!this.formulaFilled[i]) {
        error[i] = true;
        continue;
      }
      let allParts = this.formula[i].split(" ").filter(v => v != "⊕").map(v => v.replace(/[^0-9]/gi, ""));
      let solution = [];
      for (let p of allParts) {
        solution.push(this.message.split("")[+p - 1]);
      }

      if (i == this.dimension[0] + this.dimension[1]) {
        solution = [];
        for (let p of allParts) {
          solution.push(correctc[+p - 1]);
        }
      }

      if (this.formulaFilled[i].trim() != solution.join(" ⊕ ")) {
        error[i] = true;
      }
    }

    if (error.filter(v => v).length > 0) {
      this.messageService.addAlertWithTimeout(this.get("errorInFormulaFilled").concat(": ", error.map((v, i) => [v, i + 1]).filter(v => v[0]).map(v => "c".concat(v[1])).join(", ")), "danger", 10000);
      return;
    }

    let errorC = correctc.map((v, i) => [v, i]).filter(v => v[0] != this.c[v[1]]).map(v => 'c'.concat((v[1] + 1).toString()));

    if (errorC.length > 0) {
      this.messageService.addAlertWithTimeout(this.get("errorInC").concat(": ", errorC.join(", ")), "danger", 10000);
      return;
    }

    this.solved = true;
    this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
  }

  normalizeFormula(i: number) {
    if (this.formula[i]) {
      this.formula[i] = this.formula[i].replace(/[+]/gi, " ⊕ ").replace(/\s+/gi, " ").replace(/[^0-9⊕ac ]/gi, "");
    }
  }

  normalizeFormulaFilled(i: number) {
    if (this.formulaFilled[i]) {
      this.formulaFilled[i] = this.formulaFilled[i].replace(/[+]/gi, " ⊕ ").replace(/[^0-9⊕ ]/gi, "");
    }
  }

  autoFill() {
    let filled = 0;


    //compute the filled lines
    let filledLines: number[] = [];

    filledLines = this.formula.map((v, i) => [v, i]).filter(v => v[0] != "" && v[0] != undefined).map(v => +v[1]);
    filledLines = filledLines.concat(this.formulaFilled.map((v, i) => [v, i]).filter(v => v[0] != "" && v[0] != undefined).map(v => +v[1]));
    filledLines = filledLines.concat(this.c.map((v, i) => [v, i]).filter(v => v[0] != undefined).map(v => v[1]));
    filledLines = filledLines.filter((v, i) => filledLines.indexOf(v) == i)

    filled = filledLines.length / (this.dimension[0] + this.dimension[1] + 1);

    if (filled < 0.3) {
      this.messageService.addAlertWithTimeout(this.get("solveMore"), "info", 10000);
      return;
    }



    //check the formulas
    let solutionFormula = [];
    let error = []
    for (let i = 0; i < this.dimension[0] + this.dimension[1] + 1; i++) {
      solutionFormula.push([]);
      error.push(false);
    }

    for (let i = 0; i < this.dimension[1]; i++) {
      solutionFormula[i] = [];
      let index = i;
      while (index < this.dimension[0] * this.dimension[1]) {
        solutionFormula[i].push(index);
        index += this.dimension[1]
      }
    }


    for (let i = 0; i < this.dimension[0]; i++) {
      solutionFormula[i + this.dimension[1]] = [];
      for (let j = 0; j < this.dimension[1]; j++) {
        solutionFormula[i + this.dimension[1]].push(i * this.dimension[1] + j);
      }
    }

    for (let i = 0; i < this.dimension[1] + this.dimension[0]; i++) {
      if (filledLines.includes(i)) {
        if (!this.formula[i]) {
          error[i] = true;
          continue;
        }
        let allParts = this.formula[i].split(" ").filter(v => v != "⊕");
        for (let p of solutionFormula[i]) {
          if (!allParts.includes("a".concat((p + 1).toString())) && filledLines.includes(i)) {
            error[i] = true;
          }
        }
      }
    }

    if (!this.formula[this.dimension[1] + this.dimension[0]] && filledLines.includes(this.dimension[1] + this.dimension[0])) {
      error[this.dimension[1] + this.dimension[0]] = true;
    } else if (filledLines.includes(this.dimension[1] + this.dimension[0])) {
      let allParts = this.formula[this.dimension[1] + this.dimension[0]].split(" ").filter(v => v != "⊕");
      let error1 = false;
      let error2 = false;
      for (let i = 0; i < this.dimension[1]; i++) {
        if (!allParts.includes("c".concat((i + 1).toString()))) {
          error1 = true;
        }
        solutionFormula[this.dimension[0] + this.dimension[1]].push(i);
      }

      for (let i = this.dimension[1]; i < this.dimension[1] + this.dimension[0]; i++) {
        if (!allParts.includes("c".concat((i + 1).toString()))) {
          error2 = true;
        }
      }

      error[this.dimension[1] + this.dimension[0]] = error1 && error2;
    }


    solutionFormula[this.dimension[0] + this.dimension[1]] = [];
    for (let i = 0; i < this.dimension[1]; i++) {
      solutionFormula[this.dimension[0] + this.dimension[1]].push(i);
    }

    if (this.message == "" || this.message == undefined) {
      if (error.filter(v => v).length > 0) {
        this.messageService.addAlertWithTimeout(this.get("errorInSolved"), "danger", 10000);
        this.messageService.addAlertWithTimeout(this.get("errorInFormula").concat(": ", error.map((v, i) => [v, i + 1]).filter(v => v[0]).map(v => "c".concat(v[1])).join(", ")), "danger", 10000);
        return;
      }

      for (let i = 0; i < solutionFormula.length; i++) {
        if (!filledLines.includes(i)) {
          this.formula[i] = solutionFormula[i].map(v => "a".concat((v + 1).toString())).join(" ⊕ ");
          if (i == this.dimension[0] + this.dimension[1]) {
            this.formula[i] = solutionFormula[i].map(v => "c".concat((v + 1).toString())).join(" ⊕ ");
          }
        }
      }

      return;

    }

    //check the applied formulas
    let messageArray = [];
    let index = 0;
    for (let i = 0; i < this.dimension[0]; i++) {
      let elem = [];
      for (let j = 0; j < this.dimension[1]; j++) {
        elem[j] = this.message.charAt(index);
        index++;
      }
      messageArray.push(elem);
    }
    let correctc = this.selfcorrectingService.controlBits(messageArray, this.dimension);

    let errorF = []
    for (let i = 0; i < this.dimension[0] + this.dimension[1] + 1; i++) {
      solutionFormula.push([]);
      errorF.push(false);
    }
    let solution = [];
    for (let i = 0; i < this.dimension[1] + this.dimension[0] + 1; i++) {
      solution[i] = [];
      if ((!this.formulaFilled[i] || error[i]) && filledLines.includes(i)) {
        errorF[i] = true;
        continue;
      }
      let allParts = [];
      if (filledLines.includes(i)) {
        allParts = this.formula[i].split(" ").filter(v => v != "⊕").map(v => v.replace(/[^0-9]/gi, ""));
      } else {
        allParts = solutionFormula[i].map(v => v + 1);
      }

      for (let p of allParts) {
        solution[i].push(this.message.split("")[+p - 1]);
      }

      if (i == this.dimension[0] + this.dimension[1]) {
        solution[i] = [];
        for (let p of allParts) {
          solution[i].push(correctc[+p - 1]);
        }
      }
      if (filledLines.includes(i) && this.formulaFilled[i].trim() != solution[i].join(" ⊕ ")) {
        errorF[i] = true;
      }

    }

    let errorC = correctc.map((v, i) => [v, i]).filter((v, i) => ((v[0] != this.c[v[1]]) || errorF[i]) && filledLines.includes(i)).map(v => v[1]);

    if (errorC.length > 0) {
      this.messageService.addAlertWithTimeout(this.get("errorInSolved"), "danger", 10000);
      if (error.filter(v => v).length > 0) {
        this.messageService.addAlertWithTimeout(this.get("errorInFormula").concat(": ", error.map((v, i) => [v, i + 1]).filter(v => v[0]).map(v => "c".concat(v[1])).join(", ")), "danger", 10000);
      } else if (errorF.filter(v => v).length > 0) {
        this.messageService.addAlertWithTimeout(this.get("errorInFormulaFilled").concat(": ", errorF.map((v, i) => [v, i + 1]).filter(v => v[0]).map(v => "c".concat(v[1])).join(", ")), "danger", 10000);
      } else {
        this.messageService.addAlertWithTimeout(this.get("errorInC").concat(": ", errorC.map(v => "c".concat((v + 1).toString())).join(", ")), "danger", 10000);
      }
      return;
    }

    for (let i = 0; i < solution.length; i++) {
      if (!filledLines.includes(i)) {
        this.formula[i] = solutionFormula[i].map(v => "a".concat((v + 1).toString())).join(" ⊕ ");
        if (i == this.dimension[0] + this.dimension[1]) {
          this.formula[i] = solutionFormula[i].map(v => "c".concat((v + 1).toString())).join(" ⊕ ");
        }
        this.formulaFilled[i] = solution[i].join(" ⊕ ");
        this.c[i] = correctc[i];
      }
    }

    return;

  }




  generate() {
    this.solved = false;
    this.reset();
    switch (this.exerciseType) {
      case "intuitive": this.generateIntuitive(); break;
      case "distances": this.generateDistances(); break;
      case "createCodes": this.generateCreateCodes(); break;
      case "controlBits": this.generateControlBits(); break;
      case "reverseBit": this.generateReverseBit(); break;
      case "modulo": this.generateModulo(); break;

    }
  }


  getMethodDescription(): string {
    switch (this.exerciseType) {
      case "intuitive": return this.get("intuitiveDescription");
      case "distances": return this.get("distancesDescription").concat(" ", !this.givenPairs ? this.get("distanceExplainPairs") : "");
      case "createCodes": let result = this.get("createCodesDescription");
        if (this.showCube && this.lengthOfCodes < 6) {
          result = result.concat(this.get("createCodeUseGraphDescription"));
        } else if (this.showCube && this.lengthOfCodes > 5) {
          result = result.concat(this.get("createCodeGraphShowsDistanceDescription"));
        }
        return result;
      case "controlBits":
        result = "";
        if (this.modus == 'controlBits') {
          result = result.concat(this.get("computeBitsDescription"));
          if (this.useSymbols) {
            result = result.concat(this.get("computeBitsSymbolsDescription"), this.get("computeBitsSymbolsChangeDescription"));

          }
          return result;
        }

        if (this.modus != 'controlBits') {
          result = result.concat(this.get("encodeDescription"));
          if (this.encoding == 'cardTrick') {
            result = result.concat(this.get("encodeCardTrickDescription"));
          }
          if (this.encoding != 'cardTrick') {
            result = result.concat(this.get("encodeHammingDescription"));
          }
        }
        return result;
      case "reverseBit":
        result = "";
        if (this.modus == 'reversedCard') {
          result = this.get("reverseBitDescription");
          if (this.encoding == 'cardTrick') {
            result = result.concat(this.get("reverseBitCardTrickDescription"));
            if (this.useSymbols) {
              result = result.concat(this.get("computeBitsSymbolsDescription"));
            }
          } 
        } else {
          result = this.get("correctMessageDescription");
          if (this.encoding == 'cardTrick') {
            result = result.concat(this.get("correctMessageCardTrickDescription"));
          } else {
            result = result.concat(this.get("correctMessageHammingDescription"));
          }
        }
        return result;

      case "modulo": return this.get("moduloDescription").concat(this.message != '' && this.message != undefined ? this.get("moduloMessageDesciption") : "");
    }
  }

  checkSolution() {
    switch (this.exerciseType) {
      case "intuitive": this.checkSolutionIntuitive(); break;
      case "distances": this.checkSolutionDistances(); break;
      case "createCodes": this.checkSolutionCreateCodes(); break;
      case "controlBits": this.checkSolutionControlBits(); break;
      case "reverseBit": this.checkSolutionReversedBit(); break;
      case "modulo": this.checkSolutionModulo(); break;
    }
  }





}